import React from "react";
import { Route } from "react-router";
// import StudentTable from "../Pages/StudentPanel/StudentTable";
import TeachersPage from "../Pages/TeachersPage/TeachersPage";
import StudentsPage from "../Pages/StudentsPage/StudentsPage";
import CoursesPage from "../Pages/CoursesPage/CoursesPage";
import TuitionFeePage from "../Pages/TuitionFeePage/TuitionFee";
import ConsultationsPage from "../Pages/ConsultationsPage/ConsultationsPage";
import WorkersPlanPage from "../Pages/workersPlanPage/WorkersPlanPage"
import ConsultationCompanyPage from "../Pages/ConsultationCompanyPage/ConsultationCompanyPage";
import GroupsPage from "../Pages/GroupsPage/GroupsPage";
import CareerPage from "../Pages/CareerPage/CareerPage";
import SyllabusPage from "../Pages/SyllabusPage/SyllabusPage";
import LessonTablePage from "../Pages/LessonTablePage/LessonTablePage";
import EventsPage from "../Pages/EventsPage/EventsPage";
import { Dashboard } from "../Pages/DashboardPage/DashboardPage";
import RoomsPage from "../Pages/RoomsPage/RoomsPage";
import DiplomaPage from "../Pages/DiplomaPage/DiplomaPage";
import FinancePage from "../Pages/SalesPage/FinancePage";
import ReportPage from "../Pages/ReportPage/ReportPage";
import WhereHeardPage from "../Pages/WhereHeardPage/WhereHeardPage";
import UpdatesPage from "../Pages/UpdatesPage/UpdatesPage";
import NotificationPage from "../Pages/NotificationPage/NotificationPage";
import TeachersPaymentPage from "../Pages/TeachersPaymentPage/TeachersPaymentPage";
import QuarterlyTargetPlanPage from "../Pages/QuarterlyTargetPlanPage/QuarterlyTargetPlanPage";
import CompanyPage from "../Pages/CompanyPage/CompanyPage";
import ContractPage from "../Pages/ContractPage/ContractPage";
import StudentPerformancePage from "../Pages/StudentPerformancePage/StudentPerformancePage";

const WorkersPanelRoute = (user) => {
  // const { user } = useSelector((state) => state.user);
  const profiles = user?.profiles?.reduce(
    (profilesObj, item) => ({ ...profilesObj, [item.profile]: true }),
    {},
  );

  // console.log(profiles)
  return (
    <>
      {profiles?.courses && <Route path="/courses" element={<CoursesPage />} />}
      {profiles?.room && (
        <>
          <Route path="/room" element={<RoomsPage />} />
          <Route path="/room/calendar" element={<RoomsPage />} />
        </>
      )}
      {profiles?.students && (
        <>
          <Route path="/students" element={<StudentsPage />} />
          <Route
            path="/student-performance/:student/:group"
            element={<StudentPerformancePage />}
          />
          <Route
            path="/student-common-performance/:student/:group"
            element={<StudentPerformancePage />}
          />
        </>
      )}
      {profiles?.teachers && (
        <>
          <Route path="/teachers" element={<TeachersPage />} />
          <Route path="/teachers/mentors" element={<TeachersPage />} />
        </>
      )}
      {profiles?.salaries && (
        <>
          <Route path="/teachers-payments" element={<TeachersPaymentPage />} />
          <Route
            path="/teachers-payments/mentors-payments"
            element={<TeachersPaymentPage />}
          />

          <Route
            path="/teachers-payments/teachers"
            element={<TeachersPaymentPage />}
          />
          <Route
            path="/teachers-payments/mentors"
            element={<TeachersPaymentPage />}
          />
        </>
      )}
      {profiles?.tuitionFee && (
        <>
          <Route
            path="/tuition-fee/company"
            element={<TuitionFeePage type="company" />}
          />
          <Route
            path="/tuition-fee"
            element={<TuitionFeePage type="student" />}
          />
        </>
      )}
      {profiles?.consultation && (
        <>
          <Route path="/consultation" element={<ConsultationsPage />} />
          <Route
            path="/consultation/company"
            element={<ConsultationCompanyPage />}
          />
        </>
      )}

      {profiles?.segmentation && (
        <>
          <Route path="/workers-plan" element={<WorkersPlanPage />} />
        </>
      )}

      {profiles?.company && <Route path="/company" element={<CompanyPage />} />}

      {profiles?.contracts && (
        <Route path="/contracts" element={<ContractPage />} />
      )}

      {profiles?.sales && <Route path="/sales" element={<FinancePage />} />}
      {profiles?.groups && (
        <>
          <Route path="/groups/current" element={<GroupsPage />} />
          <Route path="/groups/waiting" element={<GroupsPage />} />
          <Route path="/groups/ended" element={<GroupsPage />} />
        </>
      )}
      {profiles?.career && <Route path="/career" element={<CareerPage />} />}
      {profiles?.quarterlyPlan && (
        <Route path="/quarterly-plan" element={<QuarterlyTargetPlanPage />} />
      )}
      {profiles?.syllabus && (
        <Route path="/syllabus" element={<SyllabusPage />} />
      )}
      {profiles?.lessonTable && (
        <>
          <Route path="/lessonTable" element={<LessonTablePage />} />
          <Route path="/" element={<LessonTablePage />} />
        </>
      )}
      {profiles?.events && <Route path="/events" element={<EventsPage />} />}
      {profiles?.dashboard && (
        <Route path="/dashboard" element={<Dashboard />} />
      )}
      {profiles?.diploma && <Route path="/diploma" element={<DiplomaPage />} />}
      {profiles?.report && <Route path="/report" element={<ReportPage />} />}
      {profiles?.whereHeard && (
        <Route path="/whereHeard" element={<WhereHeardPage />} />
      )}
      <Route path="/updates/:id/:modelName" element={<UpdatesPage />} />
      <Route path="/notifications" element={<NotificationPage />} />
    </>
  );
};

export default WorkersPanelRoute;
